import { ApiSuccessResponse } from "../../@types";
import { apiSlice } from "../../app/api/apiSlice";
import {
  Vehicle,
  VehicleAssignmentHistorySearchRequest,
  VehicleAssignmentSearchRequest,
  VehicleSearchRequest,
  VehicleSearchResponse,
  VehicleStats,
} from "./@types";

export const vehicleApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getVehicles: builder.mutation<
      ApiSuccessResponse<VehicleSearchResponse>,
      VehicleSearchRequest
    >({
      query: (requestBody) => ({
        url: "/v1/vehicle/search-by-company",
        method: "POST",
        body: { ...requestBody },
      }),
    }),
    getPartnerVehicles: builder.mutation<
      ApiSuccessResponse<VehicleSearchResponse>,
      VehicleSearchRequest
    >({
      query: (requestBody) => ({
        url: "/v1/vehicle/search-by-partner",
        method: "POST",
        body: { ...requestBody },
      }),
    }),
    addVehicle: builder.mutation<ApiSuccessResponse<any>, Record<string, any>>({
      query: (vehicleData) => ({
        url: "/v1/vehicle",
        method: "POST",
        body: { ...vehicleData },
      }),
    }),
    bulkAddVehicles: builder.mutation<
      ApiSuccessResponse<any>,
      { vehicles: Record<string, any>[] }
    >({
      query: (body) => ({
        url: "/v1/vehicle/bulk",
        method: "POST",
        body,
      }),
    }),
    getVehicleTypes: builder.query<ApiSuccessResponse<any>, void>({
      query: () => ({
        url: "/v1/vehicle/types",
        method: "GET",
      }),
    }),
    getVehicleById: builder.query<ApiSuccessResponse<Vehicle>, string>({
      query: (id) => ({
        url: `/v1/vehicle/${id}`,
        method: "GET",
      }),
    }),
    updateVehicle: builder.mutation<
      ApiSuccessResponse<any>,
      Record<string, any>
    >({
      query: (vehicleData) => ({
        url: `/v1/vehicle/${vehicleData.id}`,
        method: "PUT",
        body: { ...vehicleData },
      }),
    }),
    deleteVehicle: builder.mutation<ApiSuccessResponse<any>, string>({
      query: (id) => ({
        url: `/v1/vehicle/${id}`,
        method: "DELETE",
      }),
    }),
    assignDriver: builder.mutation<
      ApiSuccessResponse<any>,
      Record<string, any>
    >({
      query: (data) => ({
        url: "/v1/vaehicleassignment",
        method: "POST",
        body: { ...data },
      }),
    }),
    getVehicleStats: builder.query<ApiSuccessResponse<[VehicleStats]>, void>({
      query: () => ({
        url: "/v1/vehicle/admin/stats",
        method: "GET",
      }),
    }),
    getVehicleAssignments: builder.mutation<
      ApiSuccessResponse<VehicleAssignmentSearchRequest>,
      Record<string, any>
    >({
      query: (data) => ({
        url: "/v1/vehicleassignment/assignments",
        method: "POST",
        body: { ...data },
      }),
    }),
    assignVehicle: builder.mutation<
      ApiSuccessResponse<any>,
      Record<string, any>
    >({
      query: (data) => ({
        url: "/v1/vehicleassignment",
        method: "POST",
        body: { ...data },
      }),
    }),
    updateAssignment: builder.mutation<
      ApiSuccessResponse<any>,
      Record<string, any>
    >({
      query: (data) => ({
        url: `/v1/vehicleassignment/${data.id}`,
        method: "PUT",
        body: { ...data },
      }),
    }),
    deleteVehicleAssignment: builder.mutation<ApiSuccessResponse<any>, string>({
      query: (id) => ({
        url: `/v1/vehicleassignment/end/${id}`,
        method: "POST",
      }),
    }),
    getAssignmentHistory: builder.mutation<
      ApiSuccessResponse<any>,
      VehicleAssignmentHistorySearchRequest
    >({
      query: (data) => ({
        url: `/v1/vehicleassignment/${data.vehicleId ? "vehicle" : "driver"}/assignments`,
        method: "POST",
        body: { ...data },
      }),
    }),
    unassignVehicle: builder.mutation<ApiSuccessResponse<any>, string>({
      query: (id) => ({
        url: `/v1/vehicleassignment/end/${id}`,
        method: "POST",
      }),
    }),
  }),
});

export const {
  useGetVehiclesMutation,
  useGetPartnerVehiclesMutation,
  useAddVehicleMutation,
  useBulkAddVehiclesMutation,
  useGetVehicleTypesQuery,
  useGetVehicleByIdQuery,
  useUpdateVehicleMutation,
  useDeleteVehicleMutation,
  useAssignDriverMutation,
  useGetVehicleStatsQuery,
  useGetVehicleAssignmentsMutation,
  useAssignVehicleMutation,
  useUpdateAssignmentMutation,
  useDeleteVehicleAssignmentMutation,
  useGetAssignmentHistoryMutation,
  useUnassignVehicleMutation,
} = vehicleApiSlice;
